//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import Button from '@/components/Shared/Button'
import AnnouncementImg from '~/assets/svg/announcement.svg'

export default {
  name: 'MagicLinkConfirmationModal',
  components: {
    Button,
    ModalWithTitleBar,
    AnnouncementImg,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: null,
    },
    contactMethod: {
      type: String,
      default: null,
    },
  },
  methods: {
    resend() {
      this.$emit('resend', this.contactMethod)
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
